import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['submitButton', 'otherButton'];

  handleSubmit(event) {
    event.preventDefault();
    const clickedButton = event.target.querySelector('button[type="submit"]');
    this.selectOtherButtons(clickedButton);
    event.target.submit();
  }

  handleClick(event) {
    const clickedButton = event.target;
    this.selectOtherButtons(clickedButton);
  }

  selectOtherButtons(clickedButton) {
    const otherButtons = this.otherButtonTargets.filter(button => button !== clickedButton);
    this.disableOtherButtons(otherButtons);

    const otherSubmitButtons = this.submitButtonTargets.filter(button => button !== clickedButton);
    this.disableOtherButtons(otherSubmitButtons);
  }

  disableOtherButtons(otherButtons) {
    otherButtons.forEach(button => { button.disabled = true; })
  }
}
